<template>
  <div>
    <div class="banner inner withoutImg">
      <div class="container">
        <div class="caption">
          <div>
            <h1>
              品鉴报告
            </h1>
            <p>
              有关勃艮第产区的品鉴报告
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="breadcrumbWrap">
        <div class="breadcrumb" style="padding-top:20px">
          <span property="itemListElement" typeof="ListItem">
            <a
              property="item"
              typeof="WebPage"
              title="Go to Jasper Morris Inside Burgundy."
              href="#/"
              class="home"
            >
              <span property="name">首页</span>
            </a>
            <meta property="position" content="1">
          </span> /
          <span property="itemListElement" typeof="ListItem">
            <span property="name"><a href="#/Appraisal">品鉴笔记</a></span>
            <meta property="position" content="2">
          </span>
          <span> /
              {{details.title}}
            </span>
             <img src="./../assets/bookmark_before.png" alt="" @click="shuqian(details.id)">
        </div>
      </div>
    </div>

    <section class="innerPage">
      <div class="container">
        <rightMenu  title="分类"  :menudata='rightListdata' @OnClick='rightClick'/>
        <div class="leftCol">
          <div id="post-28821" class="post firstEditor">
            <div class="entry">
              <h2 class="noteHeading">
                <font style="vertical-align: inherit;">
                  <font style="vertical-align: inherit;">{{details.title}}</font>
                </font>
              </h2>
              <div class="noteDescription">
                <p>
                  <font style="vertical-align: inherit;" >
                    {{details.content}}
                  </font>
                </p>
              </div>
              <div class="glancegrayBg">
                <b>
                  <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;" v-if="details.score">百分制：</font>
                  </font>
                </b>
                <span class="score">
                  <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">{{details.score}}</font>
                  </font>
                </span>
                <b>
                  <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;" >星级：</font>
                  </font>
                </b>
                <div class="star-ratings-sprite">
                    <img src="https://image.insideburgundy.cn/redstar.png" v-if="details.starRating>0">
                    <img src="https://image.insideburgundy.cn/redstar.png"  v-if="details.starRating>1">
                    <img src="https://image.insideburgundy.cn/redstar.png"  v-if="details.starRating>2">
                    <img src="https://image.insideburgundy.cn/redstar.png"  v-if="details.starRating>3">
                    <img src="https://image.insideburgundy.cn/redstar.png"  v-if="details.starRating>4">

                </div>
              </div>
              <div class="noteList">
                <template v-for="(item,index) in keybody">
                <p  v-if="item.key" :key='index'>
                  <b>
                    <font style="vertical-align: inherit;">
                      <font style="vertical-align: inherit;">{{item.name}}：</font>
                    </font>
                  </b>
                  <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">{{item.key}}</font>
                  </font>
                </p>

                </template>

                <p class="tasting_location_date">
                  <b>
                    <font style="vertical-align: inherit;">
                      <font style="vertical-align: inherit;">品鉴日期：</font>
                    </font>
                  </b>
                  <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">{{details.tastingDate}}&nbsp;&nbsp;</font>
                  </font>
                  <b>
                    <font style="vertical-align: inherit;">
                      <font style="vertical-align: inherit;">品鉴地点：</font>
                    </font>
                  </b>
                  <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">{{details.tastingLocation}}&nbsp;&nbsp;</font>
                  </font>
                  <b>
                    <font style="vertical-align: inherit;">
                      <font style="vertical-align: inherit;">品鉴人：</font>
                    </font>
                  </b>
                  <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">{{details.tastingBy}}&nbsp;&nbsp;</font>
                  </font>
                </p>
              </div>
              <div class="ViewReport" v-if="details.tastingReportId">
                <b>
                  <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">出现在以下品鉴报告中</font>
                  </font>
                </b>
                <ul>
                  <li>
                    <a
                      :href="'#/Qualification?id='+details.tastingReportId"
                    >
                      <font style="vertical-align: inherit;">
                        <font style="vertical-align: inherit;">{{details.tastingReportTitle}}</font>
                      </font>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
import ajax from '../ajax';
import rightMenu from '../template/rightMenu'

let keybody = {
  wineColour:'颜色',
  producer:'酒庄',
  appellation:'AOC',
  vineyard:'田块',
  cru:'级别',
  vintage:'村子',
  cote:'子产区',
  region:'产区',
  country:'国家',
  organic:'有机/生物动力',
  grape:'葡萄品种'
}

export default {
  data(){
    return {
      details:{},
      keybody:[],
      rightListdata:{},
      userId:"",
      relatedType:"",
      relatedId:"",
    }
  },
  components:{
    rightMenu
  },
  created() {
    this.getTastingNote();
    this.getRightdata()

  },
  methods: {
     shuqian(id){
      ajax.getVserInfe({
        userId:this.$store.state.userdata.userId,
        relatedType: 2,
        relatedId: id,
          }
        // this.$store.state.userdata.userId
        ).then(res=>{
          console.log(res.data);
        alert("已添加到书签");
      });
      console.log(id)
    },
    getRightdata(){
      ajax.getReportCategories().then(res=>{
        this.rightListdata = res.data
      })
    },
    rightClick(data){
      if(!data.child&&data.id)
      this.$router.push({path:'/Qualification',query:{id:data.id}})
    },
    getTastingNote(){
      ajax.getTastingNote(this.$route.query.id).then(res=>{
        this.details = res.data;
        if(res.data.organic){
           res.data.organic = res.data.organic=='Organic'?'有机':'生物动力';
        }
        for(let item in keybody){
          this.keybody.push({
            name:keybody[item],
            key:res.data[item]
          })
        }
      })
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Tastingnotes.vue